import { ApiService } from "@/config";
import { THistoryRes } from "../models";
import { handleError } from "@/utils/parseApiReturn";

const defaultRoute = "/processes";

const getHistory = async (
  page: number,
  searchParam: string,
  accountId: number,
  limit: number,
  orderBy: string
): Promise<THistoryRes> => {
  try {
    const res = await ApiService.get(
      defaultRoute + `/${accountId}/get-processes`,
      {
        page,
        searchParam,
        limit,
        orderBy
      }
    );
    return res.data;
  } catch (error: unknown) {
    return handleError(error, "Erro na requisição para obter histórico:");
  }
};

export const HistoryService = {
  getHistory
};
